import React from 'react';
import Photo from '../Photo';
import { getPhotoBySizeForRemoteSubmission } from '../../../../services/api/generated/client';
import { useRemoteSubmissionContext } from '../../../pages/RemoteSubmission/RemoteSubmissionProvider';
const PhotoShare = (props) => {
    const { token } = useRemoteSubmissionContext();
    return (React.createElement(Photo, { ...props, query: (signal) => getPhotoBySizeForRemoteSubmission(token, props.photo.id, props.size, {
            signal,
        }) }));
};
export default PhotoShare;
